import { render, staticRenderFns } from "./classeumWayBill.vue?vue&type=template&id=456f6d50&"
import script from "./classeumWayBill.vue?vue&type=script&lang=js&"
export * from "./classeumWayBill.vue?vue&type=script&lang=js&"
import style0 from "./classeumWayBill.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports